import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './Component/Home'
import './App.css';
import Navbar from './Component/Navbar';
import ScrollToTop from './Component/ScrollToTop';
import Footer from './Component/Footer';
function App() {
  return (
    <>
    <Navbar/>
      <Home/>
      <ScrollToTop/>
      <Footer/>
    </>
  );
}

export default App;
